export default __webpack_public_path__ + "static/media/card-3.35f20c66.svg";